import { Controller } from "@hotwired/stimulus";

function escapeHtml(text) {
  const d = document.createElement("div");
  d.textContent = text;
  return d.innerHTML;
}

// Summary: compact line with bold numbers + "Summary:"; regular labels and bullets (design spec).
export default class extends Controller {
  static targets = ["compactLine"];
  static values = { strings: Object, matchedCount: Number };

  connect() {
    this.form = this.element.closest("form");
    this.refresh();
  }

  refresh() {
    if (!this.form || !this.hasCompactLineTarget) return;

    const s = this.stringsValue || {};
    const sep = s.sep || " • ";
    const parts = [];

    if (s.producer_segment) parts.push(s.producer_segment);

    const yearInputs = Array.from(
      this.form.querySelectorAll('input[name="report_prefs[payroll_years][]"]'),
    );
    const yearVals = yearInputs
      .map((el) => (el.value || "").trim())
      .filter(Boolean);
    yearVals.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
    const payrollPrefix = (s.payroll_prefix || "Payroll").trim();
    let payrollText = "";
    if (yearVals.length > 0) {
      payrollText = `${payrollPrefix} ${yearVals.join(", ")}`;
    } else {
      payrollText = s.years_empty || "";
    }
    if (payrollText) parts.push(payrollText);

    const monthAbbr = Array.isArray(s.month_abbr) ? s.month_abbr : [];
    const sm = this.form.querySelector('[name="report_prefs[start_month]"]');
    const sy = this.form.querySelector('[name="report_prefs[start_year]"]');
    const em = this.form.querySelector('[name="report_prefs[end_month]"]');
    const ey = this.form.querySelector('[name="report_prefs[end_year]"]');
    const startMonthNum = parseInt(sm?.value, 10);
    const endMonthNum = parseInt(em?.value, 10);
    const startY = sy?.value || "";
    const endY = ey?.value || "";
    const startM =
      startMonthNum >= 1 && startMonthNum <= 12
        ? monthAbbr[startMonthNum - 1] || ""
        : "";
    const endM =
      endMonthNum >= 1 && endMonthNum <= 12
        ? monthAbbr[endMonthNum - 1] || ""
        : "";
    const dash = s.duration_dash || "-";
    if (startM && startY && endM && endY) {
      parts.push(`${startM} ${startY} ${dash} ${endM} ${endY}`);
    }

    const n = this.matchedCountValue || 0;

    const audRow = this.form.querySelectorAll("[data-row-auditors]");
    const lwcRow = this.form.querySelectorAll("[data-row-lwc]");
    let audN = 0;
    let lwcN = 0;
    if (audRow.length > 0) {
      audN = Array.from(audRow).filter((el) => el.checked).length;
    } else {
      audN = this.form.querySelector(
        'input[name="report_prefs[share_with_auditors]"]',
      )?.checked
        ? n
        : 0;
    }
    if (lwcRow.length > 0) {
      lwcN = Array.from(lwcRow).filter((el) => el.checked).length;
    } else {
      lwcN = this.form.querySelector(
        'input[name="report_prefs[living_wage_contribution]"]',
      )?.checked
        ? n
        : 0;
    }

    const label = s.compact_summary_label || "Summary:";
    const facSuf = s.compact_facilities_suffix || " Facilities";
    const audSuf = s.compact_auditors_suffix || " Sharing with auditors";
    const lwcSuf = s.compact_lwc_suffix || " requesting LW contribution";

    // Bold: "Summary:", N, A, L. Regular: suffix phrases and bullets.
    this.compactLineTarget.innerHTML = [
      `<span class="font-bold">${escapeHtml(label)}</span>`,
      `<span class="font-normal"> </span>`,
      `<span class="font-bold">${escapeHtml(String(n))}</span>`,
      `<span class="font-normal">${escapeHtml(facSuf)}${escapeHtml(sep)}</span>`,
      `<span class="font-bold">${escapeHtml(String(audN))}</span>`,
      `<span class="font-normal">${escapeHtml(audSuf)}${escapeHtml(sep)}</span>`,
      `<span class="font-bold">${escapeHtml(String(lwcN))}</span>`,
      `<span class="font-normal">${escapeHtml(lwcSuf)}</span>`,
    ].join("");

    const detail = parts.filter(Boolean).join(sep);
    if (detail) {
      this.compactLineTarget.setAttribute(
        "title",
        detail.length > 120 ? detail.slice(0, 120) + "…" : detail,
      );
    }
  }
}
